import React, {Component} from "react";
import axios from "axios";
import {Col, Container, Row} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import {removeUserSession} from "../Utils/Security";
import CustomAlert from "./CustomAlert";
import CalculatorResult from "./CalculatorResult";

class Calculator extends Component {

    componentDidMount() {
        this.retrieveCBAUserInputList()
    }

    state = {
        cbaUserInputList: [],
        startUp: '',
        averageManagement: '',
        discountRate: '',
        shareOfKm: '',
        multiplier: '',
        transportOccupancy: '',
        shareOfDelivery: '',
        taxCost: '',
        hasError: false,
        errorMessage: null,
        formSubmitted: false,
        submittedSuccessfully: false,
        results: '',
        validated: false,
        baselineCase: this.props.location.state.baselineCase,
        chosenCase: this.props.location.state.chosenCase,
        subUseCase: this.props.location.state.subUseCase,
        policyYear: this.props.location.state.policyYear,
        gdpPerCapita: this.props.location.state.gdpPerCapita,
        cityPopulation: this.props.location.state.cityPopulation,
        travelSplitPublicTransport: this.props.location.state.travelSplitPublicTransport,
        travelSplitActiveTravel: this.props.location.state.travelSplitActiveTravel,
    }


    retrieveCBAUserInputList = () => {
        axios.get("/api/pst/cba_user_input", {}).then(resp => {
            this.setState({cbaUserInputList: resp.data});
            this.state.cbaUserInputList.forEach((cba) => {
                this.updateCBAValue(cba, cba.defaultValue);
            });
        });
    }

    back = () => {
        this.props.history.push('/pst');
    }

    onUpdateCBAValue(param, event) {
        return this.updateCBAValue(param, event.target.value);
    }

    updateCBAValue(param, val) {
        if (!param) {
            return;
        }

        switch (param.code) {
            case 'START_UP':
                this.onSelectStartUp(val);
                break;
            case 'AVERAGE_MANAGEMENT':
                this.onSelectAverageManagement(val);
                break;
            case 'DISCOUNT_RATE':
                this.onSelectDiscountRate(val);
                break;
            case 'SHARE_OF_KM':
                this.onSelectShareOfKm(val);
                break;
            case 'MULTIPLIER':
                this.onSelectMultiplier(val);
                break;
            case 'TRANSPORT_OCCUPANCY':
                this.onSelectTransportOccupancy(val);
                break;
            case 'SHARE_OF_DELIVERY':
                this.onSelectShareOfDelivery(val);
                break;
            case 'SELECT_TAX_COST':
                this.onSelectTaxCost(val);
                break;
            default:
                // do nothing
                break
        }
    }

    onSelectStartUp(val) {
        this.setState({startUp: val});
    }

    onSelectAverageManagement(val) {
        this.setState({averageManagement: val});
    }

    onSelectDiscountRate(val) {
        this.setState({discountRate: val});
    }

    onSelectShareOfKm(val) {
        this.setState({shareOfKm: val});
    }

    onSelectMultiplier(val) {
        this.setState({multiplier: val});
    }

    onSelectTransportOccupancy(val) {
        this.setState({transportOccupancy: val});
    }

    onSelectShareOfDelivery(val) {
        this.setState({shareOfDelivery: val});
    }

    onSelectTaxCost(val) {
        this.setState({taxCost: val});
    }

    onSubmit = (event) => {
        let self = this;
        this.setState({formSubmitted: true});
        this.setState({hasError: false});
        this.setState({submittedSuccessfully: false});
        event.preventDefault();

        const form = event.currentTarget;

        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        }

        event.preventDefault();
        if (form.checkValidity() === false) {
            event.stopPropagation();
            this.setState({validated: true});
            return;
        }

        let request = {
            startUp: this.state.startUp,
            averageManagement: this.state.averageManagement,
            discountRate: this.state.discountRate,
            shareOfKm: this.state.shareOfKm,
            multiplier: this.state.multiplier,
            transportOccupancy: this.state.transportOccupancy,
            shareOfDelivery: this.state.shareOfDelivery,
            taxCost: this.state.taxCost,
            baselineCase: this.state.baselineCase,
            chosenCase: this.state.chosenCase,
            subUseCase: this.state.subUseCase.id,
            policyYear: this.state.policyYear,
            gdpPerCapita: this.state.gdpPerCapita,
            cityPopulation: this.state.cityPopulation,
            travelSplitActiveTravel: this.state.travelSplitActiveTravel,
            travelSplitPublicTransport: this.state.travelSplitPublicTransport
        };

        // Request made to the backend api
        // Send formData object
        axios.post("/api/cba_calculator", request)
            .then(resp => {
                this.setState({results: resp.data});
                this.setState({submittedSuccessfully: true});
            }).catch(function (error) {
            switch (error.response.status) {
                case 403:
                    removeUserSession();
                    window.location.href = '/pst';
                    break;
                default:
                    self.setState({hasError: true});
                    let errorMessage = error.response && error.response.data && error.response.data.length > 0 ?
                        error.response.data[0].description : 'Something went wrong. Please try again'
                    self.setState({errorMessage: errorMessage});
                    break;
            }
        });
    }

    onUpdateImpactValue(param, event) {
        return this.updateCBAValue(param, event.target.value);
    }

    searchPage() {
        return <Container>
            <Form noValidate
                  validated={this.state.validated}
                  onSubmit={this.onSubmit}
                  className="mt-4 mb-5">

                <div className="row py-2">
                    <a href="" onClick={this.back} className="btn btn-outline-primary btn-sm">Back</a>
                </div>

                <div className="mb-5">
                    <h2 className="text-center">Calculator</h2>
                </div>


                <Row>
                    {this.state.cbaUserInputList.map((param) => (
                        <Col key={param.id} xs={12} md={12}>
                            <Form.Group md="12" controlId={param.id}>
                                <Form.Label>{param.name}</Form.Label>
                                <Form.Control type="number" step="any" min="0" lang="en_US"
                                              defaultValue={param.defaultValue}
                                              placeholder={param.defaultValue}
                                              onChange={(e) => this.onUpdateCBAValue(param, e)}/>
                                <Form.Text id={param.id} muted>
                                    {param.description}
                                </Form.Text>
                                <Form.Control.Feedback type="invalid">
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                    ))}
                </Row>

                {this.renderButtons()}


                <Row>
                    <Col xs={12} md={{span: 6, offset: 3}}>
                        {this.renderError()}
                    </Col>
                </Row>
            </Form>
        </Container>
    }

    sendToResult() {
        return <CalculatorResult results={this.state.results}/>
    }

    renderError() {
        if (this.state.hasError) {
            return <CustomAlert variant={'danger'} message={this.state.errorMessage}/>;
        }
    }

    renderButtons() {
        let display = this.state.useCase && this.state.subUseCase && this.state.baseScenario;

        if (this.state.enableSecondMeasure) {
            display = display && this.state.secondUseCase && this.state.secondSubUseCase;
        }

        return (<Row>
            <Col xs={12} md={{span: 6, offset: 3}}>
                <Button block type="submit">Submit</Button>
            </Col>
        </Row>)
    }

    render() {
        const submittedSuccessfully = this.state.submittedSuccessfully;
        let component;
        if (submittedSuccessfully) {
            component = this.sendToResult();
        } else {
            component = this.searchPage();
        }

        return (
            <div>
                {component}
            </div>
        )
    }


}


export default Calculator;